<div class="mode-notebook-cell-stderr-header" *ngIf="filteredResults?.length" (click)="showWarnings = !showWarnings">
  <capra-icon icon="icon-caret-right" [class.closed]="showWarnings"></capra-icon>

  <span [ngPlural]="filteredResults?.length">
    <ng-template ngPluralCase="=0">Warnings</ng-template>
    <ng-template ngPluralCase="=1">1 Warning</ng-template>
    <ng-template ngPluralCase="other">{{ filteredResults.length }} Warnings</ng-template>
  </span>
</div>

<ng-container *ngIf="showWarnings">
  <mode-notebook-cell-result *ngFor="let cell of filteredResults" [cell]="cell"> </mode-notebook-cell-result>
</ng-container>
